export default "__VITE_ASSET__fe1675e3__"